import './index.scss';

import { OutrosProdutos } from '../../components/outros-produtos';
import Cambio01 from '../../../../assets/images/para-sua-empresa/img-cambio01@2x.png';
import Cambio02 from '../../../../assets/images/para-sua-empresa/img-cambio02.png';
import Cambio03 from '../../../../assets/images/para-sua-empresa/img-cambio03.png';
import useScreenSize from '../../../../hooks/useScreenSize';
import { useEffect, useState } from 'react';

export const CambioPronto = () => {
    const size = useScreenSize();
    const [smallLayout, setSmallLayout] = useState(false)

    useEffect(() => {
        setSmallLayout(size.width < 900)
    },[size])

    return (
        <div className='teste-cambio'>

            <div className='container-principal empresa'>
                <div className='sombra-title'>
                    <h1> [ Câmbio Pronto ] </h1>
                </div>
            </div>
            <div className='dados-empresa'>
                <div>
                    <div>
                        <h1>
                            Fazemos o básico bem feito: transações de câmbio para qualquer natureza.
                        </h1>
                        <p>
                            Usamos a tecnologia de ponta para rastrear, em tempo real, as melhores taxas do mercado, mas sem
                            abrir mão de um atendimento humanizado, pois, para nós, cada cliente é único e criamos soluções
                            personalizadas diante do segmento que ele opera e das necessidades de seu negócio.
                        </p>
                    </div>
                    <div className='buttons-style'>
                        <a href='https://wa.me/5511973667387' target="_blank" rel="noopener noreferrer" > Fale com um especialista </a>
                    </div>
                </div>
            </div>
            {smallLayout? 
            <div className='restdados-empresa-min'> 
                <div>
                    <h1> [ Consultoria especializada ] </h1>
                    <div className='dados-img'>
                        <img alt={Cambio01} src={Cambio01} />
                    </div>
                    <p>
                        Entendemos que o mercado global tem diversas particularidades.
                        Por isso, nossa estrutura foi arquitetada para garantir a execução
                        perfeita de suas operações juntamente com velocidade e atratividade
                        em relação a custo.
                    </p>
                    <p>
                        Nossa expertise aliada a possibilidade de termos múltiplos players
                        liquidantes,
                        <span style={{ fontWeight: 'bold', marginLeft: '3px' }}>
                            conseguimos entender e executar com perfeição aos
                            operações que envolvem exposição em commodities e questões
                            atreladas à elas como: sanções, altas taxas, negociação com
                            países sensíveis
                        </span>
                    </p>
                </div>
                <div>
                    <h1> [ Múltiplas cotações ] </h1>
                    <div className='dados-img'>
                        <img alt={Cambio02} src={Cambio02} />
                    </div>
                    <p>
                        Para operacionalização e precificação das operações de cambiais,
                        cada banco possuí seu perfil de apetite ao risco e regras de
                        Compliance, impactanto diretamente em sua performance
                        operacional ( custo, agilidade e praticidade).
                    </p>
                    <p>
                        A Cobalt possui muitos players liquidantes, desde os grandes bancos
                        até os bancos de nicho cambial. No dia a dia, o nosso trader fará as
                        cotações em todos os players, em tempo real,
                        <span style={{ fontWeight: 'bold', marginLeft: '3px' }}>
                            garantindo as melhores ofertas condições do mercado financeiro.
                        </span>
                    </p>
                </div>
                <div>
                    <h1> [ Cashback ] </h1>
                    <div className='dados-img'>
                        <img alt={Cambio03} src={Cambio03} />
                    </div>
                    <p>
                        Como é de praxe no mercado, toda operação cambial sofre a
                        cobrança do spread: uma margem que as instituições financeiras
                        adicionam ao preço das moedas para cobrir custos operacionais,
                        garantir lucro e viabilidade financeira.
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold', marginLeft: '3px' }}>
                            Utilizando a Cobalt, você tem cashback <br />
                            em todas as operações fechadas.
                        </span>
                    </p>
                </div>
            </div> 
            :
            <div className='restdados-empresa'>
                <div>
                    <div className='dados-img'>
                        <img alt={Cambio01} src={Cambio01} />
                    </div>
                    <div className='dados-text'>
                        <h1> [ Consultoria especializada ] </h1>
                        <p>
                            Entendemos que o mercado global tem diversas particularidades.
                            Por isso, nossa estrutura foi arquitetada para garantir a execução
                            perfeita de suas operações juntamente com velocidade e atratividade
                            em relação a custo.
                        </p>
                        <p>
                            Nossa expertise aliada a possibilidade de termos múltiplos players
                            liquidantes,
                            <span style={{ fontWeight: 'bold', marginLeft: '3px' }}>
                                conseguimos entender e executar com perfeição aos
                                operações que envolvem exposição em commodities e questões
                                atreladas à elas como: sanções, altas taxas, negociação com
                                países sensíveis
                            </span>
                        </p>
                    </div>
                </div>
                <div>
                    <div className='dados-text'>
                        <h1> [ Múltiplas cotações ] </h1>
                        <p>
                            Para operacionalização e precificação das operações de cambiais,
                            cada banco possuí seu perfil de apetite ao risco e regras de
                            Compliance, impactanto diretamente em sua performance
                            operacional ( custo, agilidade e praticidade).
                        </p>
                        <p>
                            A Cobalt possui muitos players liquidantes, desde os grandes bancos
                            até os bancos de nicho cambial. No dia a dia, o nosso trader fará as
                            cotações em todos os players, em tempo real,
                            <span style={{ fontWeight: 'bold', marginLeft: '3px' }}>
                                garantindo as melhores ofertas condições do mercado financeiro.
                            </span>
                        </p>
                    </div>
                    <div className='dados-img'>
                        <img alt={Cambio02} src={Cambio02} />
                    </div>
                </div>
                <div>
                    <div className='dados-img'>
                        <img alt={Cambio03} src={Cambio03} />
                    </div>
                    <div className='dados-text' >
                        <h1> [ Cashback ] </h1>
                        <p>
                            Como é de praxe no mercado, toda operação cambial sofre a
                            cobrança do spread: uma margem que as instituições financeiras
                            adicionam ao preço das moedas para cobrir custos operacionais,
                            garantir lucro e viabilidade financeira.
                        </p>
                        <p>
                            <span style={{ fontWeight: 'bold', marginLeft: '3px' }}>
                                Utilizando a Cobalt, você tem cashback <br />
                                em todas as operações fechadas.
                            </span>
                        </p>
                    </div>
                </div>
            </div>
            }
            <div>
                <OutrosProdutos />
            </div>

        </div>

    )

}
